import {useState} from "react";
import styled from "styled-components/macro";

import {useParams} from "react-router-dom";
import Header from "../../../components/header";
import TopBar from "../../../components/top_bar";
import SortBar from "../../../components/sort_bar";
import CommunityHeader from "../../../components/community_header";
import Container from "../../../components/container";
import Main from '../../../components/main';
import Sidebar from "../../../components/sidebar";
import Footer from "../../../components/footer";
import Wrapper from "../../../components/wrapper";
import {useCommunityFilter, useCommunityStyle, useSaveFilter} from "../../../api/communities";
import {useBaseCommunity} from "../../../store/hooks";
import HeaderData from "../../../components/header_data";
import {useFeedback} from "../../../store/feedback";
import {isPseudoCommunity} from "../../../store/communites";
import {Textarea} from "@chakra-ui/react";
import CommunityInfo from "../../../components/community_info";
import LegacySortBar from "../../../components/legacy/legacy_sort_bar";
import useWindowDimensions from "../../../utils/dimensions";

const Form = styled.div``;
const Save = styled.div``;
const Status = styled.div``;

const Filter = styled(({className}) => {
    const {error, feedbackCh} = useFeedback();
    const baseCommunity = useBaseCommunity();
    const {community: paramsCommunity} = useParams();
    const community = paramsCommunity || baseCommunity;
    const style = useCommunityStyle(community);
    const [code, setCode] = useState('');
    useCommunityFilter(feedbackCh, community, setCode);

    const [saving, setSaving] = useState(false);
    const saveFilter = useSaveFilter(feedbackCh);
    const handleSave = async () => {
        if (saving) return;
        try {
            setSaving(true);
            await saveFilter(community, code);
        } catch {
            // error is displayed
        }
        setSaving(false);
    };

    const {width} = useWindowDimensions();

    return (
        <>
            <HeaderData title={`Community Filter`} community={community} community_style={style}/>
            <Header>
                {(baseCommunity !== "TheDonald" || width <= 780) && <TopBar legacyConversion={baseCommunity === "TheDonald"} />}
                {!isPseudoCommunity(community) &&
                    <>
                        <CommunityHeader community={community}/>
                        {baseCommunity !== "TheDonald" &&
                            <CommunityInfo desktop community={community}/>
                        }
                    </>
                }
                {baseCommunity === "TheDonald" && width > 780 && <LegacySortBar />}
            </Header>
            <SortBar community={community} />
            <Container className={className} forceWidth={"slim"}>
                <Wrapper>
                    <Main>
                        <h3>Manage Community Filter</h3>
                        <Form>
                                <Textarea
                                    value={code}
                                    language="yaml"
                                    placeholder="/* YAML goes here */"
                                    onChange={(evn) => setCode(evn.target.value)}
                                    padding={'16px'}
                                    minHeight={380}
                                />
                            <Status>
                                {error?.toString()}
                                <Save onClick={handleSave}>{saving ? 'Saving...' : 'Save'}</Save>
                            </Status>
                        </Form>
                    </Main>
                </Wrapper>
                <Sidebar sidebar={style?.sidebar} community={community} />
            </Container>
            <Footer />
        </>
    );
})`
  ${Main} {
    padding: 24px;
  }
  ${Form}  {
    max-width: 720px;
  }
  h3 {
    font-size: 18px !important;
    line-height: 18px;
    padding-bottom: 16px;
    margin: 0 !important;
  }
  ${Save} {
    width: 96px;
    margin-left: auto;
    margin-top: 8px;
    text-align: center;
    padding: 8px;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    border: 1px solid ${({theme}) => theme.color.name === 'dark' ? theme.dark_border : theme.white_2};
  }
  ${Status} {
    display: flex;
    align-items: center;
  }
`;

export default Filter;
